import { useMemo, useState } from 'react'
import type { ProductSelectOption } from '../constants/product-select'
import {
  areAllIdsSelected,
  filterNamedProducts,
  mergeSelectedIds,
  removeSelectedIds,
  selectedNamedProducts,
} from '../helpers/product-select'
import { toggleProductId } from '../helpers/vendor'

export function useProductMultiSelect(
  products: ProductSelectOption[],
  selectedIds: string[],
  onChange: (ids: string[]) => void,
) {
  const [query, setQuery] = useState('')
  const visible = useMemo(
    () => filterNamedProducts(products, query),
    [products, query],
  )
  const visibleIds = useMemo(
    () => visible.map((product) => product.id),
    [visible],
  )
  const selectedProducts = useMemo(
    () => selectedNamedProducts(products, selectedIds),
    [products, selectedIds],
  )
  const allVisibleSelected = areAllIdsSelected(visibleIds, selectedIds)

  function toggle(productId: string) {
    onChange(toggleProductId(selectedIds, productId))
  }

  function selectVisible() {
    onChange(mergeSelectedIds(selectedIds, visibleIds))
  }

  function clearSelection() {
    if (query.trim()) {
      onChange(removeSelectedIds(selectedIds, visibleIds))
      return
    }
    onChange([])
  }

  return {
    query,
    setQuery,
    visible,
    selectedProducts,
    allVisibleSelected,
    toggle,
    selectVisible,
    clearSelection,
  }
}
